
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    components: {}
})
export default class TooltipDialog extends Vue {
    @Prop() readonly text: string;
    tooltip = false;

}
